export default __webpack_public_path__ + "static/media/link.a164ff3d.svg";